import React from 'react';
import { isEmpty } from 'lodash';

import { Container } from './styles';

interface Props {
  errors: string[];
}
export const ValidationErrorsList = (props: Props) => {
  const { errors } = props;

  if (isEmpty(errors)) {
    return null;
  }

  return (
    <Container>
      <ul>
        {errors.map((error) => (
          <li key={error}>{error}</li>
        ))}
      </ul>
    </Container>
  );
};
